




import Vue from "vue";
import Component from "vue-class-component";
import router, { ROUTES } from "@/router";
import { UserStore, RiskProfileStore, RoleStore } from "@/store";

@Component
export default class Logout extends Vue {
  mounted() {
    this.logout();
  }

  async logout() {
    // Todo Invlidate token on server side
    await RiskProfileStore.Reset();
    await RoleStore.ClearUserRoles();
    await UserStore.Logout();
    location.reload();
  }
}
